import { db } from '../../firebase/firebaseConfig';
import { collection, addDoc, Timestamp, doc, setDoc } from 'firebase/firestore';
import { createReservation } from '../business/reservationService';

const NAMES = ['Ahmet Yılmaz', 'Mehmet Demir', 'Ayşe Kaya', 'Fatma Çelik', 'Mustafa Öztürk'];
const PLATES = ['34 ABC 123', '34 XYZ 789', '06 ANK 001', '35 IZM 3535', '16 BUR 1616', '07 ANT 0707'];
const TRANSPORTERS = [
    { name: 'Ekol Lojistik', id: 'ekol', shortName: 'EKOL' },
    { name: 'Mars Lojistik', id: 'mars', shortName: 'MARS' },
    { name: 'Horoz Lojistik', id: 'horoz', shortName: 'HOROZ' },
    { name: 'Reysaş', id: 'reysas', shortName: 'REYSAS' }
];

export const generateTestReservations = async (tenantId, count = 10) => {
    console.log(`Generating ${count} test reservations for tenant: ${tenantId}`);

    // Get Docks (Simulated or fetched)
    // We'll generate random dock IDs if we can't fetch easily, but better to fetch?
    // For simplicity, we assume some dock IDs exist or we pass null (waiting list)

    const today = new Date();
    today.setHours(8, 0, 0, 0);

    const generatedIds = [];

    for (let i = 0; i < count; i++) {
        const randomTran = TRANSPORTERS[Math.floor(Math.random() * TRANSPORTERS.length)];
        const randomPlate = PLATES[Math.floor(Math.random() * PLATES.length)];
        const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];

        // Random time between 8:00 and 18:00
        const startHour = 8 + Math.floor(Math.random() * 10);
        const startMin = Math.floor(Math.random() * 4) * 15; // 0, 15, 30, 45

        const startTime = new Date(today);
        startTime.setHours(startHour, startMin, 0, 0);

        const duration = 30 + Math.floor(Math.random() * 3) * 30; // 30, 60, 90
        const endTime = new Date(startTime);
        endTime.setMinutes(endTime.getMinutes() + duration);

        const payload = {
            tenantId,
            plateNumber: `${randomPlate}-${Math.floor(Math.random() * 100)}`, // Unique-ish
            transporterId: randomTran.id,
            transporterName: randomTran.name,
            transporterShortName: randomTran.shortName,
            driverName: randomName,
            driverPhone: '5551234567',
            vehicleType: 'TIR',
            status: 'pending', // Waiting list
            dockId: null, // Start in waiting list
            startTime: null, // No slot yet
            endTime: null,
            metrics: {
                volume: 30 + Math.floor(Math.random() * 50),
                weight: 5 + Math.floor(Math.random() * 15),
                fullness: 50 + Math.floor(Math.random() * 50)
            },
            notes: 'Test Verisi'
        };

        // 50% chance to be assigned to a dock (simulated)
        // We won't assign dockId blindly to avoid foreign key issues in UI if dock doesn't exist.
        // Users can drag and drop them.

        try {
            const id = await createReservation(payload);
            generatedIds.push(id);
        } catch (e) {
            console.error("Gen Error", e);
        }
    }

    return generatedIds;
};
